import {EditUser} from './edit-user';

export default EditUser;